import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
// import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
// 视频工具的路由
export var constantRoutesTools = [{
  path: '/',
  redirect: '/light-app/format-conversion'
}, {
  path: '/light-app',
  component: function component() {
    return import('@/layout/main-light-app');
  },
  redirect: '/light-app/format-conversion',
  children: [{
    name: 'formatConversion',
    path: 'format-conversion',
    component: function component() {
      return import('@/views/video-tools/format-conversion.vue');
    },
    meta: {
      title: '视频格式转换',
      icon: ''
    }
  }, {
    name: 'combine',
    path: 'combine',
    component: function component() {
      return import('@/views/video-tools/combine.vue');
    },
    meta: {
      title: '视频合并',
      icon: ''
    }
  }, {
    name: 'variableSpeed',
    path: 'variable-speed',
    component: function component() {
      return import('@/views/video-tools/variable-speed.vue');
    },
    meta: {
      title: '视频变速',
      icon: ''
    }
  }, {
    name: 'rotate',
    path: 'rotate',
    component: function component() {
      return import('@/views/video-tools/rotate.vue');
    },
    meta: {
      title: '视频旋转',
      icon: ''
    }
  }, {
    name: 'watermarkImg',
    path: 'watermark-img',
    component: function component() {
      return import('@/views/video-tools/watermark-img.vue');
    },
    meta: {
      title: '在线添加图片水印',
      icon: ''
    }
  }, {
    name: 'watermarkTxt',
    path: 'watermark-txt',
    component: function component() {
      return import('@/views/video-tools/watermark-text.vue');
    },
    meta: {
      title: '在线添加文字水印',
      icon: ''
    }
  }, {
    name: 'screenshot',
    path: 'screenshot',
    component: function component() {
      return import('@/views/video-tools/screenshot.vue');
    },
    meta: {
      title: '在线视频截图',
      icon: ''
    }
  }, {
    name: 'cutVideo',
    path: 'cut-video',
    component: function component() {
      return import('@/views/video-tools/cut-video.vue');
    },
    meta: {
      title: '在线视频截取',
      icon: ''
    }
  }, {
    name: 'cutGif',
    path: 'cut-gif',
    component: function component() {
      return import('@/views/video-tools/cut-gif.vue');
    },
    meta: {
      title: '在线GIF截取',
      icon: ''
    }
  }]
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: '/light-app',
  component: function component() {
    return import('@/layout/main-light-app');
  },
  redirect: '/light-app/format-conversion',
  children: [{
    name: 'formatConversion',
    path: 'format-conversion',
    component: function component() {
      return import('@/views/video-tools/format-conversion.vue');
    },
    meta: {
      title: '视频转码',
      icon: ''
    }
  }, {
    name: 'combine',
    path: 'combine',
    component: function component() {
      return import('@/views/video-tools/combine.vue');
    },
    meta: {
      title: '视频合并',
      icon: ''
    }
  }, {
    name: 'variableSpeed',
    path: 'variable-speed',
    component: function component() {
      return import('@/views/video-tools/variable-speed.vue');
    },
    meta: {
      title: '视频变速',
      icon: ''
    }
  }, {
    name: 'rotate',
    path: 'rotate',
    component: function component() {
      return import('@/views/video-tools/rotate.vue');
    },
    meta: {
      title: '视频旋转',
      icon: ''
    }
  }, {
    name: 'watermarkImg',
    path: 'watermark-img',
    component: function component() {
      return import('@/views/video-tools/watermark-img.vue');
    },
    meta: {
      title: '在线添加图片水印',
      icon: ''
    }
  }, {
    name: 'watermarkTxt',
    path: 'watermark-txt',
    component: function component() {
      return import('@/views/video-tools/watermark-text.vue');
    },
    meta: {
      title: '在线添加文字水印',
      icon: ''
    }
  }, {
    name: 'watermarkTxt',
    path: 'watermark-txt',
    component: function component() {
      return import('@/views/video-tools/watermark-text.vue');
    },
    meta: {
      title: '在线添加文字水印',
      icon: ''
    }
  }, {
    name: 'screenshot',
    path: 'screenshot',
    component: function component() {
      return import('@/views/video-tools/screenshot.vue');
    },
    meta: {
      title: '在线视频截图',
      icon: ''
    }
  }, {
    name: 'cutVideo',
    path: 'cut-video',
    component: function component() {
      return import('@/views/video-tools/cut-video.vue');
    },
    meta: {
      title: '在线视频截取',
      icon: ''
    }
  }, {
    name: 'cutGif',
    path: 'cut-gif',
    component: function component() {
      return import('@/views/video-tools/cut-gif.vue');
    },
    meta: {
      title: '在线GIF截取',
      icon: ''
    }
  }]
}, {
  path: '/',
  component: function component() {
    return import('@/layout/main');
  },
  children: [{
    path: '',
    redirect: 'entries'
  }, {
    path: '/entries',
    name: 'entries',
    component: function component() {
      return import('@/views/entries/index');
    },
    meta: {
      title: '',
      icon: ''
    }
  }, {
    path: '/text',
    name: 'text',
    component: function component() {
      return import('@/views/text/index');
    },
    meta: {
      title: '文本审核'
    }
  }, {
    path: '/video',
    component: function component() {
      return import('@/views/video/index');
    },
    meta: {
      title: '视频审核',
      icon: ''
    }
  }, {
    path: '/image',
    component: function component() {
      return import('@/views/image/index');
    },
    meta: {
      title: '图片审核',
      icon: ''
    }
  }, {
    path: '/audio',
    component: function component() {
      return import('@/views/audio/index');
    },
    meta: {
      title: '音频审核',
      icon: ''
    }
  }]
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: process.env.VUE_APP_NAME === 'tools' ? constantRoutesTools : constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;